export default __webpack_public_path__ + "static/media/logo_mpim.34f62c3d.png";